import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import PropTypes from 'prop-types';

import { Divider, Typography } from '@material-ui/core';

import * as convert from '_core/utils/convert';
import * as http from '_core/utils/http';
import { useGlobal } from '_core/hooks/useGlobal';
import { useSearch } from '_core/hooks/useSearch';
import { withLang } from '_core/hocs/withLang';
import { DeliveryWidget } from '_core/views/CartSteps';
import { PaymentBrief } from '_core/components/PaymentBrief';
import { PaymentFee } from '_core/components/PaymentFee';
import { PaymentInternal } from '_core/components/PaymentInternal';
import { PaymentSwitch } from '_core/components/PaymentSwitch';
import { Price } from '_core/components/Price';
import { PriceMix } from '_core/components/PriceMix';
import { StepsControls } from '_core/components/StepsControls';
import { TopupOption } from '_core/components/TopupOption';

import { useStyle } from './style';


export const RawPaymentStepWidget = (props) => {
  const {
    load,
    cache,
    payment,
    goPrev,
    onClose,
    getLangString: l
  } = props;
  
  const classes = useStyle();
  
  const {
    config: { ROUTE_URL }
  } = useGlobal();
  
  const history = useHistory();
  const location = useLocation();
  const { getSearchParam } = useSearch();
  
  const paymentData = cache.payment || load.payment || payment;
  
  const shop = getSearchParam('shop');
  const documentId = convert.toInt(paymentData?.document || getSearchParam('document'));
  const requestId = convert.toInt(getSearchParam('request'));
  const product = getSearchParam('payment');
  
  
  const pagePath = location.pathname;
  const returnPath = ROUTE_URL.CART;
  const paymentPath = returnPath + '/payment';
  //const completePath = returnPath + '/success';
  
  const requestOrigin = typeof window !== 'undefined' ? window.location.origin : '';
  const requestSuccessUrl = requestOrigin + process.env.PUBLIC_URL + paymentPath + '/' + documentId + '/' + requestId;
  const requestErrorUrl = http.param(requestSuccessUrl, { cancel: 'y' });
  const requestIsError = getSearchParam('cancel') === 'y';
  
  
  return (
    <DeliveryWidget
      type="payment"
      documents={[documentId]}
      request={requestId}
      
      requestSuccessUrl={requestSuccessUrl}
      requestErrorUrl={requestErrorUrl}
      requestIsError={requestIsError}
      
      onNextPage={(req) => {
        if (req) {
          history.push(http.param(pagePath, { shop, payment: product, document: documentId, request: req.id }));
        } else {
          onClose();
        }
      }}
      onPrevPage={(error) => {
        if (requestId) {
          history.push(http.param(pagePath, { shop, payment: product, document: documentId }));
        } else {
          goPrev();
        }
      }}
    />
  );
};

RawPaymentStepWidget.defaultProps = {};

RawPaymentStepWidget.propTypes = {
  // self props
  deliveryData: PropTypes.object.isRequired,
  order: PropTypes.object,
  payment: PropTypes.object,
  cache: PropTypes.object.isRequired,
  goPrev: PropTypes.func.isRequired,
  load: PropTypes.object.isRequired,

  // `withLang` HOC props
  langInfo: PropTypes.object,
  langStrings: PropTypes.object,
  getLangObject: PropTypes.func,
  getFirstLangString: PropTypes.func,
  getLangStringSet: PropTypes.func,
  getLangString: PropTypes.func.isRequired,
};

export const PaymentStepWidget = withLang(RawPaymentStepWidget);
